import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App"; // app dumbass
import "./index.css"; // style

// Firebase sht
import "./assets/Logic/firebase";
import "./assets/Logic/auth";

// React setup
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
